import { render } from "./CustomTextInput.vue?vue&type=template&id=04218408&scoped=true&ts=true"
import script from "./CustomTextInput.vue?vue&type=script&lang=ts"
export * from "./CustomTextInput.vue?vue&type=script&lang=ts"

import "./CustomTextInput.vue?vue&type=style&index=0&id=04218408&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04218408"]])

export default __exports__